import React, { memo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf } from "@fortawesome/free-regular-svg-icons";
import { handleEnterKeyToClick } from "../../common/accessibilityHelpers";
import { Box, Link } from "@mui/material";
import { DocumentHeader } from "types/documents/DocumentHeader";

export type DocumentLinkProps = {
  document: DocumentHeader;
  onDocumentClick?: (document: DocumentHeader) => void;
};

export const DocumentLink = memo(function DocumentLink(
  props: DocumentLinkProps
): JSX.Element {
  return (
    props.document && (
      <Link
        component="li"
        sx={{
          display: "inline-flex",
          cursor: "pointer",
          textDecoration: "none",
          color: "#005a9e",
          fill: "#005a9e",
            "&:hover": {
                color: "#033d69",
                fill: "#033d69",
            },      
        }}
        gap={1}
        onClick={() => props.onDocumentClick?.(props.document)}
        aria-label="Click to download document"
        onKeyUp={handleEnterKeyToClick}
      >
        <Box mr={1} display="inline-block">
        <FontAwesomeIcon icon={faFilePdf} aria-label="Document File"  />
        </Box>
        {props.document.filename}
      </Link>
    )
  );
});
